import React from 'react';
import { Poly } from './poly';

export const Polygon = ({ height, width, dpr }) => {
  return <Poly height={height} width={width} />;
};
